import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { ref } from "vue";
import { audioPlayStream } from "@/js/common";
import { textToPlayAudio } from "@/js/textToPlayAudio";
import newAudio1 from "../../../../public/images/newaudio1.svg";
import newAudio2 from "../../../../public/images/newaudio2.svg";
import newAudio3 from "../../../../public/images/newaudio3.svg";

export default /*@__PURE__*/_defineComponent({
  __name: 'AudioComp',
  props: {
    word: { default: "" },
    color: { default: "" }
  },
  setup(__props: any) {

const props = __props;
const audioPlayer = ref();
const mediaType = ref();
const bofangIcon = ref(newAudio3);
const bofangArr = [newAudio1, newAudio2, newAudio3];
const timer = ref(0);
function streamAudioPlay1() {
  // openAi播放
  if (audioPlayer.value) {
    pauseAudio();
    return;
  }
  audioPlayStream(props.word, (callbackData: any, type: string) => {
    console.log(callbackData);
    console.log(type);
    mediaType.value = type;
    if (mediaType.value === "MEDIA_SOURCE") {
      let num = 0;
      audioPlayer.value = new Audio(callbackData);
      audioPlayer.value.oncanplay = function () {
        audioPlayer.value.play();
      };
      audioPlayer.value.onended = function () {
        console.log("ended");
        pauseAudio();
      };
      audioPlayer.value.oncanplaythrough = () => {
        console.log("loading");
        clearInterval(timer.value);
        timer.value = window.setInterval(() => {
          num = ++num % 3;
          bofangIcon.value = bofangArr[num];
        }, 300);
      };
    } else if (mediaType.value === "AUDIO_CONTEXT") {
      audioPlayer.value = callbackData;
    }
  });
}
function streamAudioPlay() {
  if (audioPlayer.value) {
    pauseAudio();
    return;
  }
  textToPlayAudio(props.word, (url) => {
    let num = 0;
    mediaType.value = "MEDIA_SOURCE";
    if (mediaType.value === "MEDIA_SOURCE") {
      audioPlayer.value = new Audio(url);
      audioPlayer.value.oncanplay = function () {
        audioPlayer.value.play();
      };
      audioPlayer.value.onended = function () {
        console.log("ended");
        pauseAudio();
      };
      audioPlayer.value.oncanplaythrough = () => {
        console.log("loading");
        clearInterval(timer.value);
        timer.value = window.setInterval(() => {
          num = ++num % 3;
          bofangIcon.value = bofangArr[num];
        }, 300);
      };
    }
  });
}
function pauseAudio() {
  if (audioPlayer.value) {
    if (mediaType.value === "MEDIA_SOURCE") {
      audioPlayer.value.pause();
      audioPlayer.value = null;
    } else if (mediaType.value === "AUDIO_CONTEXT") {
      audioPlayer.value.close();
      audioPlayer.value = null;
    }
    bofangIcon.value = bofangArr[2];
    clearInterval(timer.value);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    class: "iconfont bofang-icon",
    src: bofangIcon.value,
    style: _normalizeStyle({ color: props.color }),
    onClick: streamAudioPlay
  }, null, 12, _hoisted_1))
}
}

})